import type { ReactNode } from 'react';

import { TableCell, TableRow } from '../../primitives/table';

type Props = {
    colSpan: number;
    spinner: ReactNode;
    /** Extra classes for the row — some tables (like client-table's CSS-grid override) key layout
     *  off the row's class list, so no one default fits every consumer. */
    rowClassName?: string;
    /** Extra classes for the cell — most commonly a fixed height, reserved regardless of fetch
     *  state so the spinner never shifts scroll height. */
    cellClassName?: string;
};

// Centered via an inner flex wrapper, not a class on the cell — a CSS-grid table sets the cell's
// own `display` (client-table's `.table-cell` override), which would win that fight silently.
export function VirtualTableLoadingRow({ colSpan, spinner, rowClassName, cellClassName }: Props) {
    return (
        <TableRow className={rowClassName}>
            <TableCell colSpan={colSpan} className={cellClassName}>
                <div className="flex items-center justify-center">{spinner}</div>
            </TableCell>
        </TableRow>
    );
}
